<!------------------------------

      Page Actions

------------------------------->
@if (!isInModalContext && !isInIntegratedContext) {
  <ng-container *sbPageAction>
    <button
      *ngPermissions="permissionService.Permission.campaign_type_create"
      type="button"
      sb-button-primary
      [color]="'green'"
      [icon]="'plus'"
      [loading]="loading()"
      [iconButton]="true"
      [sbRouterLink]="util.RoutingID.campaignTypeCreate"
      sbTooltip="{{ 'lang.campaignTypes.createCampaignType | translate }}"
    >
    </button>

    <button
      type="button"
      sb-button-primary
      color="blue"
      sbTooltip="{{ 'lang.globals.refresh' | translate }}" placement="top"
      container="body"
      [iconButton]="true"
      [icon]="'refresh'"
      (click)="requestDebounced()"
      [disabled]="loading()"
      [loading]="loading()">
    </button>

  </ng-container>
}

<!------------------------------

     Table Wrapper

------------------------------->

<sb-table-wrapper-new
  headline="{{'nav.datasets.campaignTypes' | translate}}"
  [isInModalContext]="isInModalContext"
  [itemsData]="hierarchies"
  (paginationChange)="requestDebounced($event)"
  [loading]="loading()"
  [itemName]="'campaignTypes'">

  <!------------------------------

      Filter Panel

------------------------------->

  <div filter-panel class="tw-bg-[#F8F9FC] dark:tw-bg-sbGray-930 tw-rounded-l-xl">
    <sb-filter-panel
      (filterChange)="applyFiltering($event)"
      [headerClasses]="'tw-bg-sbGray-50 dark:tw-bg-sbGray-930 tw-border-solid tw-border-0 tw-z-40 tw-border-b tw-border-sbGray-500 dark:tw-border-sbGray-50 tw-h-[60px] tw-rounded-tl-xl'"
      [config]="filterConfig"
    >

    </sb-filter-panel>
  </div>

  <!------------------------------

     Table Header

------------------------------->
  <ng-template #thead>

    <tr>
      <th>
        {{'lang.globals.id' | translate}}
      </th>
      <th>
        {{'lang.globals.name' | translate}}
      </th>
      <th>
        {{'lang.globals.description' | translate}}
      </th>
      <th class="sticky-col last-col">
        {{ 'lang.globals.action' | translate }}
      </th>
    </tr>
  </ng-template>

  <!------------------------------

      Table Body

------------------------------->
  <ng-template #tbody let-item>
    <tr [attr.data-object]="item?.id">
      <td>
        {{ item.id }}
      </td>
      <td>
        <sb-comp-name-wrapper>
          <sb-comp-link firstLine
                        [title]="item.name"
                        [permission]="permissionService.Permission.campaign_type_edit"
                        [condition]="!isInModalContext && !isInIntegratedContext"
                        [link]="util.RoutingID.campaigns"
                        [queryParams]="{'campaignTypeIds': getItemId(item)}"
                        [tooltip]="'lang.globals.openDetails' | translate">
          </sb-comp-link>
          <sb-tags secondLine
                   *ngPermissions="[permissionService.Permission.tag_list]" [tags]="item.tags"
                   [dtoType]="tagService.TaggableDTO.CampaignType" [dtoId]="item.id">
          </sb-tags>
        </sb-comp-name-wrapper>
      </td>
      <td>
        {{ item.description }}
      </td>
      <td class="tr bw sticky-col last-col">
        @if (!isInModalContext && !isInIntegratedContext) {
          <sb-split-button
            [splitButtonItems]="item.sbButtons ?? []"
          ></sb-split-button>
        } @else {
          <button sb-button-secondary
                  type="button"
                  ngbTooltip="{{'lang.globals.select' | translate}}"
                  (click)="selectCampaignType(item)"
                  [icon]="'boxChecked'"
                  [color]="'blue'"
                  [iconButton]="true">
          </button>
        }
      </td>
    </tr>
  </ng-template>
  <!------------------------------

    Card Element

------------------------------->

  <!-- no card element -->

</sb-table-wrapper-new>
